



















































import Vue from 'vue';
import { api, MEMBER_API_SUB_URLS } from '@/api';
import { CloseFullscreenWrapper, TriggerRefreshError } from '@/mixins';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  card: any;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  TriggerRefreshError,
).extend({
  name: 'CancelAllDebitCards',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      card: this.params.card,
    };
  },
  computed: {
    contentCallout(): string {
      const cardLast4Text = this.card.cardLast4Digits
        ? ` (…${this.card.cardLast4Digits})`
        : '';
      return `${this.card.firstName} ${this.card.lastName}${cardLast4Text}`;
    },
  },
  methods: {
    confirmCancelAllCards(): void {
      this.isLoading = true;
      // REST-019
      api
        .post(
          `${MEMBER_API_SUB_URLS.debitCards}/${this.card.dependentId}/terminate`,
          {
            memberId: this.$store.getters.user.memberId,
            cardPackageId: `${this.card.cardPackageKey}`,
          },
        )
        .then(() => {
          this.refreshDependents();

          // GTM Event - Delete Card
          window.dataLayer.push({
            event: 'deleteCard',
          });
        })
        .catch(() => {
          this.showSuccessMessage = false;
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshDependents(): void {
      this.$store
        .dispatch('getDependents')
        .then(() => {
          this.showErrorMessage = false;
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'cancel-all-cards_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
